import {Modal, Input, Form, Button, message, Cascader} from 'antd'
import {goodsCategorySave, goodsCategoryUpdateById} from "@/services/goods.ts";
import {useEffect, useMemo, useState} from "react";
import {cloneDeep, isEmpty} from "lodash-es";
import {deleteObjNodeById, trimStr} from "@/utils/data.ts";

const CategoryModal = props => {
  const { open, onClose, fn, record } = props
  const [ form ] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    form.resetFields()
    if(open && !isEmpty(record)) {
      const cateIdPath = record.cateIdPath?.split('>')
      const parentIdPath = cateIdPath?.slice(1, record.id ? cateIdPath.length - 1 : cateIdPath.length);
      form.setFieldsValue({...record, parentId: parentIdPath})
    }
  }, [open]);

  const newTreeData = useMemo(() => {
    const data = cloneDeep(props.cateTreeList)
    if(record.id && !isEmpty(data)){
      deleteObjNodeById(data, record.parentId, record.id)
    }
    return data;
  },[props.cateTreeList, record.id])

  const save = () => {
    form.validateFields().then((values) => {
      setBtnLoading(true)
      const apiUrl = values.id ? goodsCategoryUpdateById : goodsCategorySave
      const parentId = values.parentId ? (values.parentId[values.parentId.length - 1] || 0) : values.id ? '' : record.parentId
      apiUrl({...values, parentId}).then(res=>{
        message.success(res?.message || '操作成功');
        onClose?.()
        fn?.()
      }).finally(() => setBtnLoading(false))
    });
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={500}
      title={ record.id ? "编辑分类" : "新增分类" }
      footer={[
        <Button loading={btnLoading} key="cancel" onClick={onClose}>
          取消
        </Button>,
        <Button loading={btnLoading} key="save" type="primary" onClick={save}>
          保存
        </Button>,
      ]}
    >
      <Form
        style={{ padding: "10px 0" }}
        form={form}
        layout={'vertical'}
        labelCol={{
          span: 6,
        }}
      >
        <Form.Item hidden name={'id'}><Input/></Form.Item>
            <Form.Item
              name="parentId"
              label="父级分类"
              hidden={!record.id}
            >
              <Cascader changeOnSelect
                        expandTrigger={'hover'}
                        displayRender={(labels: string[]) => labels[labels.length - 1]}
                        options={newTreeData}
                        fieldNames={{ value: 'id'}}
                        placeholder={'请选择父级分类'}
              />
            </Form.Item>
        <Form.Item
          name="cateName"
          label="分类名称"
          rules={[
            {
              required: true,
              message: '分类名称不能为空',
            },
          ]}
        >
          <Input maxLength={15} showCount onChange={(v:any):void => {
            form.setFieldValue('cateName', trimStr(v.target.value))
          }}/>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CategoryModal
